import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ReactTooltip from "react-tooltip";
import Toast from "react-bootstrap/Toast";
import axios from "axios";
import moment from "moment";
import { QuestionCircle } from "react-bootstrap-icons";
import { REQUIRED_FIELDS, INVITED } from "./constants";
import DatePicker from "react-datepicker";
import {
    emailValidation,
    emailVerifyMatch,
    userNameValidation,
    ssnValidation
} from "./validation";
import { getIPAddress } from "./utils/getIPAddress";
import { analytics } from "./analytics";
import { Header, Footer, DisclaimerPolicyOwner } from "./components";
import "react-datepicker/dist/react-datepicker.css";
import Enumerable from "linq";
//import { useSearchParams } from 'react-router-dom';

const InvitedUserEnroll = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const payload = searchParams.get("payload");
    const decodedPayload = JSON.parse(atob(payload));

    const [user, setUser] = useState({
        firstName: Enumerable.from(decodedPayload)
            .where((x) => x.key === "firstname")
            .select((x) => x.value)
            .firstOrDefault(),
        lastName: Enumerable.from(decodedPayload)
            .where((x) => x.key === "lastname")
            .select((x) => x.value)
            .firstOrDefault(),
        email: Enumerable.from(decodedPayload)
            .where((x) => x.key === "email")
            .select((x) => x.value)
            .firstOrDefault(),
        verifyEmail: Enumerable.from(decodedPayload)
            .where((x) => x.key === "email")
            .select((x) => x.value)
            .firstOrDefault(),
        tenant: Enumerable.from(decodedPayload)
            .where((x) => x.key === "caller")
            .select((x) => x.value)
            .firstOrDefault(),
        invitationCode: Enumerable.from(decodedPayload)
            .where((x) => x.key === "referrer")
            .select((x) => x.value)
            .firstOrDefault(),
        suffix: Enumerable.from(decodedPayload)
            .where((x) => x.key === "suffix")
            .select((x) => x.value)
            .firstOrDefault(),
        middleName: Enumerable.from(decodedPayload)
            .where((x) => x.key === "middleName")
            .select((x) => x.value)
            .firstOrDefault(),
        id: "",
        password: "",
        secondaryPhoneNumber: "",
        policyNumber: "",
        dob: "",
        ssnTIN: "",
        role: Enumerable.from(decodedPayload)
            .where((x) => x.key === "role")
            .select((x) => x.value)
            .firstOrDefault(),
        inviteRole: Enumerable.from(decodedPayload)
            .where((x) => x.key === "inviteRole")
            .select((x) => x.value)
            .firstOrDefault()
    });
    const [errors, setErrors] = useState({
        firstName: "",
        lastName: "",
        email: "",
        verifyEmail: "",
        middleName: "",
        suffix: "",
        phoneNumber: "",
        policyNumber: "",
        dob: "",
        ssnTIN: ""
    });
    if (user.phoneNumber) {
        user.phoneNumber =
            user.phoneNumber.indexOf("+") > -1
                ? user.phoneNumber
                : `+1${user.phoneNumber}`;
    }
    const [toastMessage, setToastMessage] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [submitting, setsubmitting] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(user.phoneNumber);

    useEffect(() => {
        analytics();
    }, []);

    useEffect(() => {
        const role = INVITED;
        const requiredFields = REQUIRED_FIELDS[role];
        if (user.inviteRole === "entity_owned") {
            requiredFields.push("ssnTIN");
        } else {
            requiredFields.push("dob");
        }

        for (const element of requiredFields) {
            const fieldName = element;
            if (!user[fieldName]) {
                setSubmitDisabled(true);
                return;
            }
        }

        const errorFields = Object.keys(errors);
        for (const element of errorFields) {
            const fieldName = element;
            if (errors[fieldName] !== "") {
                setSubmitDisabled(true);
                return;
            }
        }
    }, [user, errors]);

    useEffect(() => {
        document.title = `Invited User Registration | Pacific Life`;
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const payload = { [name]: value };
        setUser((prev) => ({ ...prev, ...payload }));
    };

    const handleBlur = async (e) => {
        const { name, value } = e.target;
        let errorMessage = "";
        if (name === "id") {
            const validUserName = userNameValidation(value);
            const tooShortOrLongUserName =
                value.length < 6 || value.length > 15;
            if (value.indexOf(" ") > -1) {
                errorMessage = "Username name should not contain space";
            }
            if (/[^a-zA-Z0-9-. ]/.test(value)) {
                errorMessage = "Username must not contain special characters";
            }
            if (validUserName) {
                errorMessage = "";
            } else if (tooShortOrLongUserName) {
                errorMessage =
                    "Username must be between 6 and 15 characters long";
            }
        }
        if (name === "firstName") {
            if (value.length === 0) {
                errorMessage = "First Name must be entered";
            } else if (/[^a-zA-Z0-9]/.test(value)) {
                errorMessage =
                    "First Name must not contain spaces or numbers or special characters";
            } else {
                errorMessage = "";
            }
        }
        if (user.inviteRole === "entity_owned") {
            if (name === "ssnTIN") {
                const valid = ssnValidation(value);
                errorMessage = valid
                    ? ""
                    : "Enter a valid tax identification number";
            }
        } else {
            if (name === "dob") {
                if (value.length === 0) {
                    errorMessage = "Insured's Date of Birth must be entered";
                } else {
                    errorMessage = "";
                }
            }
        }

        if (name === "middleName") {
            if (value.length > 0) {
                if (/[^a-zA-Z0-9-. ]/.test(value)) {
                    errorMessage =
                        "Middle Name must not contain numbers or special characters";
                }
            } else {
                errorMessage = "";
            }
        }

        if (name === "suffix") {
            if (value.length > 0) {
                if (/[^a-zA-Z0-9-. ]/.test(value)) {
                    errorMessage =
                        "Suffix must not contain numbers or special characters";
                } else {
                    errorMessage = "";
                }
            }
        }

        if (name === "policyNumber") {
            if (value.length === 0) {
                errorMessage = "Policy must be entered";
            } else if (/[^a-zA-Z0-9]/.test(value)) {
                errorMessage =
                    "Policy Number must not contain spaces or numbers or special characters";
            } else {
                errorMessage = "";
            }
        }

        if (name === "lastName") {
            if (value.length === 0) {
                errorMessage = "Last Name must be entered";
            } else if (/[^a-zA-Z0-9]/.test(value)) {
                errorMessage =
                    "Last Name must not contain spaces or numbers or special characters";
            } else {
                errorMessage = "";
            }
        }

        if (name === "email") {
            const emailValid = emailValidation(value);
            errorMessage = emailValid ? "" : "Enter valid email";
        }

        if (name === "verifyEmail") {
            errorMessage = emailVerifyMatch(user.email, value)
                ? ""
                : "Email addresses do not match";
        }

        if (name === "phoneNumber") {
            if (value.length === 0) {
                errorMessage = "Phone number should not be mandatory";
            } else if (value.length === 10) {
                errorMessage = "Country code is mandatory";
            } else {
                errorMessage = "";
            }
        }

        if (errorMessage !== "") {
            setSubmitDisabled(true);
        } else {
            setSubmitDisabled(false);
        }
        setErrors((prev) => ({ ...prev, [name]: errorMessage }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let errMsg = "";
        setsubmitting(true);
        const payload = await formatPayloadProfile();
        try {
            const res = await axios({
                method: "PUT",
                url: "/life/enroll/api/userenroll/client/invited/register",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload)
            }).catch(function (err) {
                if (err.response) {
                    errMsg = err.response?.data?.error?.message || "";
                    console.log(
                        err.response?.data?.error?.message ||
                            err.response?.data ||
                            "Something went wrong. Please try again later."
                    );
                    setToastMessage(
                        errMsg ||
                            "Something went wrong. Please try again later."
                    );
                } else if (err.request) {
                    console.log(err.request);
                } else {
                    console.log("Error", err.message);
                }
            });
            if (res.status === 200) {
                window.location.href =
                    "/policy-owner-login/account/reg-successful.html";
            }
        } catch (error) {
            setToastMessage(
                errMsg ||
                    error.response?.data?.errorMessage ||
                    "Something went wrong. Please try again later."
            );
        }

        setsubmitting(false);
    };

    const formatPayloadProfile = async () => {
        return {
            id: "",
            firstName: user.firstName,
            lastName: user.lastName,
            secondaryPhone: user.secondaryPhoneNumber,
            email: user.email.trim(),
            userId: user.id,
            tenant: "MLA",
            invitationCode: user.invitationCode,
            removeEventListenerole: user.role,
            middleName: user.middleName,
            password: user.password.trim(),
            ipAddress: await getIPAddress(),
            suffix: user.suffix,
            role: "client",
            ssnTin: user.ssnTIN,
            policyNumber: user.policyNumber,
            dateOfBirth:
                user.inviteRole === "entity_owned"
                    ? ""
                    : moment(user.dob).format("MM/DD/YYYY")
        };
    };

    const closeToast = () => {
        setToastMessage("");
    };

    return (
        <>
            {toastMessage !== "" && (
                <Toast onClose={closeToast} className="toast-cont">
                    <Toast.Header>
                        <strong className="me-auto">{toastMessage}</strong>
                    </Toast.Header>
                </Toast>
            )}
            <Header />
            <div className="mainMyAccount">
                <h1 className="heading">Register</h1>
                <Form>
                    <Row>
                        <Col sm={12}>
                            <label className="sub-title">
                                Contact Information
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                                name="firstName"
                                autoComplete="off"
                                maxLength={25}
                                value={user.firstName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled="disabled"
                            />
                            <span className="validation-error-message">
                                {errors.firstName}
                            </span>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                                name="lastName"
                                autoComplete="off"
                                maxLength={35}
                                value={user.lastName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled="disabled"
                            />
                            <span className="validation-error-message">
                                {errors.lastName}
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Label>Middle Name (Optional)</Form.Label>
                            <Form.Control
                                name="middleName"
                                autoComplete="off"
                                maxLength={25}
                                value={user.middleName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.middleName}
                            </span>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Suffix (Optional)</Form.Label>
                            <Form.Control
                                name="suffix"
                                autoComplete="off"
                                maxLength={35}
                                value={user.suffix}
                                onChange={handleChange}
                            />
                            <span className="validation-error-message">
                                {errors.suffix}
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <ReactTooltip />
                            <Form.Label className="emailClass">
                                Email
                            </Form.Label>
                            <Form.Control
                                name="email"
                                autoComplete="off"
                                maxLength={60}
                                value={user.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled="disabled"
                            />
                            <span className="validation-error-message">
                                {errors.email}
                            </span>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Confirm Email</Form.Label>
                            <Form.Control
                                name="verifyEmail"
                                autoComplete="off"
                                maxLength={60}
                                value={user.verifyEmail}
                                onChange={handleChange}
                                onPaste={(e) => e.preventDefault()}
                                onBlur={handleBlur}
                                disabled="disabled"
                            />
                            <span className="validation-error-message">
                                {errors.verifyEmail}
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <ReactTooltip />
                            <Form.Label className="createUsername">
                                User Name
                                <QuestionCircle
                                    tabIndex="-1"
                                    className="iconClass"
                                    data-tip="Remember this! You will need it along with your password to access your account information"
                                />
                            </Form.Label>
                            <Form.Control
                                name="id"
                                autoComplete="off"
                                maxLength={20}
                                value={user.id}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.id}
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <label className="sub-title">
                                Policy Information
                            </label>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Label>Policy Number</Form.Label>
                            <Form.Control
                                name="policyNumber"
                                autoComplete="off"
                                maxLength={10}
                                value={user.policyNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.policyNumber}
                            </span>
                        </Col>
                        {user.inviteRole === "global_citizen" && (
                            <Col md={4}>
                                <ReactTooltip />
                                <Form.Label>Insured's Date of Birth</Form.Label>
                                <DatePicker
                                    selected={user.dob}
                                    value={user.dob}
                                    className="react-datepicker-ignore-onclickoutside"
                                    onChange={(dob) =>
                                        handleChange({
                                            target: {
                                                name: "dob",
                                                value: dob
                                            }
                                        })
                                    }
                                    showYearDropdown
                                    showMonthDropdown
                                    dropdownMode="select"
                                    placeholderText="Click to select a date"
                                    maxDate={new Date()}
                                    name="dob"
                                    //openToDate={new Date("1985/01/01")}
                                    //tabIndex={1}
                                    onBlur={handleBlur}
                                />
                                <span className="validation-error-message">
                                    {errors.dob}
                                </span>
                            </Col>
                        )}
                        {user.inviteRole === "entity_owned" && (
                            <Col md={4}>
                                <ReactTooltip />
                                <Form.Label>
                                    Tax Identification Number
                                </Form.Label>
                                <Form.Control
                                    name="ssnTIN"
                                    autoComplete="off"
                                    maxLength={9}
                                    value={user.ssnTIN}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span className="validation-error-message">
                                    {errors.ssnTIN}
                                </span>
                            </Col>
                        )}
                    </Row>

                    <div className="buttons-myaccount">
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={handleSubmit}
                            data-track="analytics"
                            disabled={submitDisabled || submitting}
                        >
                            {submitting ? "Registering" : "Register"}
                        </Button>
                    </div>
                </Form>

                <DisclaimerPolicyOwner />
            </div>
            <Footer />
        </>
    );
};

export default InvitedUserEnroll;
